import Component from "../../component";

export const ReviewsSummaryConfig = {
    signature: 'reviewsSummary',
    baseHtmlClass: 'reviews_summary',
    selector: '.reviews_summary',
    initedHtmlClassModifier: 'inited',
    datasetConfigKey: 'reviews_summary',
    identifierDatasetConfigKey: 'identifier',
    willRenderRatingDatasetConfigKey: 'will_render_rating',
    willRenderActionsDatasetConfigKey: 'will_render_actions',
    willRenderCountDatasetConfigKey: 'will_render_count'
};

export class ReviewsSummary extends Component {

    constructor(id_or_element, props={}) {
        super({
            element: id_or_element,
            config: ReviewsSummaryConfig
        });

        this.setDatasetConfig(ReviewsSummaryConfig.datasetConfigKey);
        this.willRenderRating = this.getWillRenderRating();
        this.willRenderActions = this.getWillRenderActions();
        this.willRenderCount = this.getDatasetConfigValue(ReviewsSummaryConfig.willRenderCountDatasetConfigKey) || false;

        this.ratingHtml = props.hasOwnProperty('ratingHtml') ? props.ratingHtml : '';
        this.actionsHtml = props.hasOwnProperty('actionsHtml') ? props.actionsHtml : '';
        this.countHtml = props.hasOwnProperty('reviewsCountText') ? (props.reviewsCountText ? `<p class="spr-summary-caption">${ props.reviewsCountText }</p>` : '') : '';

        this.inited = true;
        this.renderInitial();
    }

    getWillRenderRating() {
        const willRenderRating = this.getDatasetConfigValue(ReviewsSummaryConfig.willRenderRatingDatasetConfigKey);
        if (!willRenderRating) return;
        return willRenderRating;
    }

    getWillRenderActions() {
        const willRenderActions = this.getDatasetConfigValue(ReviewsSummaryConfig.willRenderActionsDatasetConfigKey);
        if (!willRenderActions) return;
        return willRenderActions;
    }

    renderInitial() {
        this.conditionallySetHtmlClassState(this.inited, ReviewsSummaryConfig.initedHtmlClassModifier);
        let content = [
            (this.rendersRating()  ? (this.ratingHtml || '') : ''),
            (this.rendersActions() ? (this.actionsHtml || '') : ''),
            (this.rendersCount()   ? (this.countHtml || '') : '')
        ]
        this.element.innerHTML = content.join(' ');
    }

    rendersRating() {
        return !!this.willRenderRating;
    }

    rendersActions() {
        return !!this.willRenderActions;
    }

    rendersCount() {
        return !!this.willRenderCount;
    }

}
